import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=c7fdeb5a&scoped=true"
import script from "./notify.vue?vue&type=script&lang=js"
export * from "./notify.vue?vue&type=script&lang=js"
import style0 from "./notify.vue?vue&type=style&index=0&id=c7fdeb5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a947b4d37137bf79d4abbd1caef86e24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fdeb5a",
  null
  
)

export default component.exports